import ResourceGetter   from '../../../../model/resource/getter/resource-getter'
import MyFooter         from '../../../views/layout-footer'
import ChangePasswordForm
                        from '../../../templates/views/user/components/ChangePasswordForm'
import DefinitionGetter
                        from '../../../../model/resource/getter/definitions-getter'
import User             from '../../../../model/resource/User'
import FormElementTypes from '../../../../model/FormElementTypes'
import AutoComplete     from '../../../forms/elements/AutoComplete'
import DependenciesLoader
                        from '../../../../model/loader/user-base-entities-loader'
import DropDown         from '../../../forms/elements/DropDown'
import PageDynamicEditor
                        from '../../../templates/views/dynamic-editor/PageDynamicEditor'

export default {

  props: [
    'parentDefinition'
  ],

  data () {
    return {
      resource: null,
      def:      null,

      defaults:           {},
      showEditSection:    false,
      image:              null,
      formValues:         {},
      formTypes:          FormElementTypes,
      originalLanguageId: null,
      languageChanged:    false
    }
  },

  components: {
    MyFooter,
    ChangePasswordForm,
    AutoComplete,
    DropDown,
    PageDynamicEditor
  },

  beforeRouteLeave (to, from, next) {
    this.$refs.editor.formDataCheckFunction(() => {next()}, () => {next()})
    this.$store.commit('setHpRedirect', true)
  },

  created () {
    this.resource = ResourceGetter.get('tUser')

    this._initDef()

    document.body.classList.add('page-profile')
  },

  updated () {
    if (this.$refs.files) {
      this.$refs.files.forEach((item) => {
        $(item).dropify()
      })
    }
  },

  destroyed () {
    document.body.classList.remove('page-profile')
  },

  methods: {

    _initDef () {
      if (this.parentDef) {
        this.def = this.parentDef
        this._initBase()
        return
      }

      DependenciesLoader
        .getProfileMenuData((response) => {
          this.def = response.data[0].Fields[0]
          this._initBase()
        }, (error) => {
          this.handleApiError(error)
        })
    },

    /**
     *
     * @private
     */
    _initBase () {
      Promise
        .all([this._initDefaults()])
        .then(() => {
          this._initFormDefinition()
          this._initImage()
        })
    },

    /**
     *
     * @private
     */
    _initImage () {
      User.getUserParams((params) => {
        this.image = JSON.parse(params.tUserImageAvatar)
      })
    },

    /**
     *
     * @return {*}
     * @private
     */
    _initFormDefinition () {
      let args = {
        code:                   this.def.Code,
        idtEntityStructureFrom: this.def.idtEntityStructureFrom
      }

      return DefinitionGetter
        .getDataDefinition(args, (response) => {
          this.def = response

          // this.def.editor.forEach((item) => {
          //   this.formValues[item.ColumnName] =
          // this.defaults[item.ColumnName]
          // })
          //
          // // @TODO: hack item attributes
          // // this must be refactored -> create form item processor shared
          // with // FormGenerator for (const item of this.def.editor) {
          // item.label       = item.Label item.viewName    = item.ViewName
          // item.code        = item.Code item.columnName  = item.ColumnName
          // item.dataType    = item.DataType item.entityType  =
          // item.EntityType item.field       = item.Field item.fieldType   =
          // item.FieldType item.fieldView   = item.FieldViewed item.readonly
          //  = item.IsReadOnly === 'true' item.items       = []
          // item.updateValue = { value:   this.defaults[item.Field], stValue:
          // this.defaults[item.FieldViewed] }  if
          // (item.hasOwnProperty('Items')) { item.items = item.Items }  item.source = { source:                 item.ViewName, value:                  item.ColumnName, label:                  item.Label, limit:                  5, idtEntity:              item.idtEntity, idtEntityStructureFrom: item.idtEntityStructureFrom, columnName:             item.ColumnName, defaults:               this.defaults, defaultValue:           this.defaults ? this.defaults[item.FieldViewed] : null } }

        }, (error) => {this.handleApiError(error)})
    },

    /**
     *
     * @private
     */
    _initDefaults () {
      this
        .resource
        .setDef(this.def)
        .getById(this.$store.getters.user.id)
        .then((response) => {
          this.defaults           = response.data[0]
          this.originalLanguageId = this.defaults['IDTLANGUAGE']
        })
    }

    // /**
    //  *
    //  * @private
    //  */
    // _formSubmit (args) {
    //
    //   return
    //   Object
    //     .keys(this.formValues)
    //     .forEach((key) => {
    //       this.defaults[key] = this.formValues[key]
    //     })
    //
    //   this
    //     .resource
    //     .update({ data: this.defaults, ID: this.defaults.ID })
    //     .then((response) => {
    //       Promise
    //         .all([this._initDefaults()])
    //         .then(() => {
    //           if (this.languageChanged) {
    //             this.$router.push({ name: 'Logout' })
    //           }
    //
    //           this.showEditSection = false
    //         })
    //     })
    //     .catch(error => {
    //       this.handleApiError(error)
    //     })
    //
    // },

    // /**
    //  *
    //  * @private
    //  */
    // _submit () {
    //   this.$refs.form.submit()
    // },

    // /**
    //  *
    //  * @private
    //  */
    // _clickEdit () {
    //   this.def.editor.forEach((item) => {
    //     this.formValues[item.ColumnName] = this.defaults[item.ColumnName]
    //   })
    //
    //   this.showEditSection = true
    // },

    // /**
    //  *
    //  * @private
    //  */
    // _clickDiscard () {
    //   this.showEditSection = false
    // },
    //
    // /**
    //  *
    //  * @private
    //  */
    // _fileChange (e) {
    //   let file   = e.target.files[0],
    //       reader = new FileReader(),
    //       data   = {}
    //
    //   reader.readAsDataURL(file)
    //
    //   reader.onload = () => {
    //     data['data'] = reader.result
    //     data['name'] = file.name
    //   }
    // },

    // _elementValueChange (args) {
    //   this.defaults[args.element.Field]   = args.value
    //   this.formValues[args.element.Field] = args.value
    //   if (args.stValue) {
    //     this.defaults[args.element.FieldViewed]   = args.stValue
    //     this.formValues[args.element.FieldViewed] = args.stValue
    //   }
    //
    //   for (const item of this.def.editor) {
    //     if (item.field === args.element.field) {
    //       item.updateValue = {
    //         value:   args.value,
    //         stValue: args.stValue
    //       }
    //     }
    //   }
    //
    //   if (args.element.field === 'IDTLANGUAGE') {
    //     if (args.value == this.originalLanguageId) {
    //       this.languageChanged = false
    //     }
    //     else {
    //       this.languageChanged = true
    //     }
    //   }
    // }
  }

}
